<template>
  <section>
    <!--工具条-->
    <Toolbar :buttonList="buttonList" @callFunction="callFunction"></Toolbar>
    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      :height="getTableHeight(165)"
      style="width: 100%"
    >
      <el-table-column :label="$t('Name')">
        <template slot-scope="scope">{{ scope.row.Name }}</template>
      </el-table-column>
      <el-table-column label="BusinessId" prop="BusinessId"></el-table-column>
      <el-table-column label="地址" width="500">
        <template slot-scope="scope">
          {{ "https://shop.koipy.com/TourDiyTab/" + scope.row.LoginKey + "/1" }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('Created')">
        <template slot-scope="scope">{{
          formatDate(scope.row.Created)
        }}</template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
    <!--新增-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      width="35%"
    >
      <el-form :model="addForm" label-width="120px" ref="addForm" size="small">
        <el-form-item
          label="Business Id"
          prop="BusinessId"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + 'Business Id',
          }"
        >
          <el-input
            v-model.number="addForm.BusinessId"
            type="text"
            style="width: 150px"
          ></el-input
          >&nbsp;
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="businessLoading"
            circle
            @click.native="verifyBusinessId(addForm.BusinessId, true)"
          ></el-button
          >&nbsp;{{ CheckBusienss.chineseName }}
        </el-form-item>
        <el-form-item
          :label="$t('Name')"
          prop="Name"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Name'),
          }"
        >
          <el-input v-model="addForm.Name"></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-switch v-model="addForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
    <!--修改-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        size="small"
      >
        <el-form-item
          label="Business Id"
          prop="BusinessId"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + 'Business Id',
          }"
        >
          <el-input
            v-model.number="editForm.BusinessId"
            type="text"
            style="width: 150px"
          ></el-input
          >&nbsp;
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="businessLoading"
            circle
            @click.native="verifyBusinessId(editForm.BusinessId, false)"
          ></el-button
          >&nbsp;{{ CheckBusienss.chineseName }}
        </el-form-item>
        <el-form-item
          :label="$t('Name')"
          prop="Name"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Name'),
          }"
        >
          <el-input v-model="editForm.Name"></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-switch v-model="editForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import {
  getBusinessConfigList,
  addBusinessConfig,
  editBusinessConfig,
  removeBusinessConfig,
  verifyBusinessId,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      filters: {
        Name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      sname: "",
      currentRow: null,
      dialogVisible: false,
      //新增界面数据
      addFormVisible: false,
      addLoading: false,
      addForm: {},
      //修改界面数据
      editFormVisible: false,
      editLoading: false,
      editForm: {},
      domain: window.location.origin,
      CheckBusienss: { chineseName: "" },
      businessLoading: false,
    };
  },
  methods: {
    verifyBusinessId(id, isadd) {
      if (id == "") {
        return;
      }
      let para = {
        bid: id,
      };
      this.businessLoading = true;
      verifyBusinessId(para).then((res) => {
        this.CheckBusienss = res.data.response;
        if (!res.data.response.chineseName) {
          this.CheckBusienss.chineseName = "未找到";
        } else {
          if (isadd) {
            this.addForm.Name = this.CheckBusienss.chineseName;
          } else {
            this.editForm.Name = this.CheckBusienss.chineseName;
          }
        }
        this.businessLoading = false;
      });
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy/MM/dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        BusinessId: 0,
        Name: "",
        Enabled: true,
        IsDeleted: false,
      };
    },
    //新增活动
    addSubmit: function () {
      let _this = this;
      if (this.addForm.number <= 0) {
        this.$message({
          message: "请输入数量",
          type: "error",
        });
        return;
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              addBusinessConfig(para).then((res) => {
                this.addLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    }, //显示编辑活动界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.clone(row));
    },
    //编辑活动
    editSubmit: function () {
      let _this = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);
              editBusinessConfig(para).then((res) => {
                this.editLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeBusinessConfig(para).then((res) => {
            this.listLoading = false;
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取列表
    getList() {
      let _this = this;
      this.listLoading = true;
      let para = {
        key: this.filters.Name,
        page: this.page,
      };
      getBusinessConfigList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
